import * as ReactDOM from "react-dom";
import {createElement} from "react";
import {App} from "./App";

ReactDOM.render(
    <App />,
    document.getElementById("content")
);
